import {combineReducers} from 'redux';
import signupReducer from './auth';
import generalReducer from './general';
import inboxReducer from './inbox';
const rootReducer = combineReducers({
  general: generalReducer,
  auth: signupReducer,
  inbox: inboxReducer,
});

export default rootReducer;
